<template>
  <b-container>
    <b-card class='text-center'>
      <h2>Login</h2>
      <b-button :to="{name: 'login_router'}">Login</b-button>
    </b-card>
  </b-container>
</template>

<script>

import { db } from '@/main.js'

const extension_resources = [
  {url: 'chrome-extension://bmnlcjabgnpnenekpadlanbbkooimhnj/paypal/button.js', name: 'Honey', tags: ['personal']},

  {url: 'chrome-extension://niloccemoadcdkdjlinkgdfekeahmflj/save.html', name: 'Pocket', tags: ['personal']},
  {url: 'chrome-extension://kbfnbcaeplbcioakkpcpgfkobkghlhen/src/popupEditorIFrame.html', name: 'Grammarly', tags: []},

  {url: 'chrome-extension://noojglkidnpfjbincgijbaiedldjfbhh/manifest.json', name: 'Buffer', tags: ['marketing', 'social_media']},
  {url: 'chrome-extension://bjgfdlplhmndoonmofmflcbiohgbkifn/images/rss/arrow.png', name: 'Hootsuite Hootlet', tags: ['marketing', 'social_media']},
  {url: 'chrome-extension://eakacpaijcpapndcfffdgphdiccmpknp/images/mozicon_19x19.png', name: 'MozBar', tags: ['marketing', 'seo']},
  {url: 'chrome-extension://cknebhggccemgcnbidipinkifmmegdel/html/content/toolbar.html', name: 'SEO Analysis & Website Review by WooRank', tags: ['marketing', 'seo']},

  {url: 'chrome-extension://kgjfgplpablkjnlkjmjdecgdpfankdle/images/loading_24.gif', name: 'Zoom Scheduler', tags: ['buisness']},

  {url: 'chrome-extension://oiiaigjnkhngdbnoookogelabohpglmd/img/hubspot-logo-16-grey.png', name: 'HubSpot Sales', tags: ['sales']},
  {url: 'chrome-extension://liecbddmkiiihnedobmlmillhodjkdmb/css/content.css', name: 'Loom', tags: ['sales']},
  {url: 'chrome-extension://jiihcciniecimeajcniapbngjjbonjan/popup.html', name: 'Vidyard', tags: ['sales']},
  {url: 'chrome-extension://nmaonghoefpmlfgaknnboiekjhfpmajh/sidebar.html', name: 'Crystal', tags: ['sales']},
  {url: 'chrome-extension://chmpifjjfpeodjljjadlobceoiflhdid/assets/content/autoclose.html', name: 'Outreach Everywhere', tags: ['sales']},
  {url: 'chrome-extension://amcdijdgmckgkkahhcobikllddfbfidi/contentSrc/forLinkedin/XMLHttpWatcher.js', name: 'Reply.io', tags: ['sales']},
  {url: 'chrome-extension://hgmhmanijnjhaffoampdlllchpolkdnj/html/source_popup.html', name: 'Hunter', tags: ['sales']},
  {url: 'chrome-extension://mfldbojpjpgjlphijlbgefdjebkhdjom/css/gmail.css', name: 'BombBomb', tags: ['sales']},

  {url: 'chrome-extension://fmkadmapgofadopljbjfkapdkoienihi/main.html', name: 'React Developer Tools', tags: ['developer']},
  {url: 'chrome-extension://nhdogjmejiglipccpnnnanhbledajbpd/devtools.html', name: 'Vue Developer Tools', tags: ['developer']},
  {url: 'chrome-extension://bhlhnicpbhignbdhedgjhgdocnmhomnp/css/content-style.css', name: 'ColorZilla', tags: ['developer', 'designer']},
  {url: 'chrome-extension://aejoelaoggembcahagimdiliamlcdmfm/images/icon/favicon.ico', name: 'Talend API Tester - Free Edition', tags: ['developer']},

  {url: 'chrome-extension://hdokiejnpimakedhajhdlcegeplioahd/overlay.html', name: 'LastPass', tags: ['security']},
  {url: 'chrome-extension://aeblfdkhhhdcdjpifhhbdiojplfjncoa/inline/menu/menu.html', name: '1Password', tags: ['security']},
  {url: 'chrome-extension://fdjamakpfbbddfjaooikfcpapjohcfmg/content/webui/index.html', name: 'Dashlane', tags: ['security']},
]

export default {
  metaInfo: {title: 'Home'},
  props: ['profile', 'user'],
  data() {
    return {
      items: [],
    }
  },
  methods: {
    async test_extensions() {
      let extensions = []
      for (let resource of extension_resources) {
        try {
          let r = await fetch(resource.url, {method: 'GET'})
          if (r.status === 200) {
            extensions.push(resource.name)
          }
        } catch (err) {
          // Failed to fetch, ignore
        }
      }
      // TODO adblock

      console.log(extensions)

      return extensions
    }
  },
  mounted() {
    this.test_extensions()
  }
}
</script>

<style scoped>

.main {
  background: white;
}

.card {
  max-width: 24em;
  margin: auto;
}

.container {
  margin-top: 8em;
}

</style>
